<template>
  <div class="rawData main-content">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('costConfirmationList.title.basicInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            v-model="baseData"
            :options="options"
            ref="baseData"
            @input="handleChangeBaseData"
            label-width="100px"
          ></base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('costConfirmationList.title.transAndStoreCost') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            v-model="baseTransData"
            :options="transOptions"
            ref="baseTransData"
            @input="handleChangeBaseTransData"
            label-width="100px"
          ></base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('costConfirmationList.title.productDetailInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="table"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :columns="column"
            :edit-rules="rules"
            :toolbar="{}"
            :valid-config="{ autoPos: true, message: 'inline' }"
            :edit-config="{ trigger: 'click', mode: 'row' }"
            show-footer
            :max-height="$store.state.app.tableHeight"
            :footer-method="footerMethod"
            :footer-span-method="footerColspanMethod"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="insertEvent(-1)"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('functionBtn.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete()"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('functionBtn.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="fixed-bottom-btnList">
      <el-button class="fixed-bottom-btn" type="primary" @click="handleSave()">{{
        $t('functionBtn.save')
      }}</el-button>
    </footer>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import API from '@/api/productCenter/costConfirm';
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  // import loading from '@/common/js/load.js';
  import DataBaseAPI from '@/api/dataBase';
  // import inputNumber from '@/components/form-item/input-number';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import DictSelect from '@/components/DictSelect';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumberAd from '@/components/form-item/input-number-advance';

  export default {
    name: 'costConfirmationAdd',
    components: {
      baseForm,
      // inputNumber,
      // DictSelect,
      // ajaxSelect,
      // SearchTable,
      // InputNumberAd,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      options() {
        return [
          {
            // 公司
            type: 'select',
            label: this.$t('costConfirmationList.column.businessCompanyCode'),
            prop: 'businessCompanyCode',
            required: true,
            options: this.companyList,
            changeMethod: 'changeCompany',
          },
          {
            // 业务部门
            type: 'select',
            label: this.$t('costConfirmationList.column.businessDepartmentCode'),
            prop: 'businessDepartmentCode',
            required: true,
            options: this.departmentList,
          },
          {
            // 操作人
            type: 'input',
            label: this.$t('costConfirmationList.column.createPersonNo'),
            prop: 'createPersonName',
            disabled: true,
            required: true,
          },
          {
            // 创建日期
            type: 'date',
            label: this.$t('costConfirmationList.column.createDate'),
            prop: 'createDate',
            disabled: true,
          },
          {
            // 结算数量
            type: 'input',
            label: this.$t('costConfirmationList.column.settlementCount'),
            prop: 'settlementCount',
            disabled: true,
            maxlength: '20',
          },
          {
            // 不含税结算金额
            type: 'amountNumber',
            label: this.$t('costConfirmationList.column.settlementAmountWithoutTax'),
            prop: 'settlementAmountWithoutTax',
            disabled: true,
            maxlength: '20',
          },
          {
            // 含税结算金额
            type: 'amountNumber',
            label: this.$t('costConfirmationList.column.settlementAmountWithTax'),
            prop: 'settlementAmountWithTax',
            disabled: true,
            maxlength: '20',
          },
          {
            // 成本确认单号
            type: 'input',
            label: this.$t('costConfirmationList.column.confirmNo'),
            prop: 'confirmNo',
            placeholder: this.$t('placeholder.auto'),
            disabled: true,
            maxlength: '20',
          },
          /* {
          // 成本确认年度
          prop: "confirmYear",
          label: this.$t("costConfirmationList.column.confirmYear"),
          type: "select",
          required: true,
          options: this.yearList,
        },
        {
          // 成本确认月份
          prop: "confirmMonth",
          label: this.$t("costConfirmationList.column.confirmMonth"),
          type: "select",
          required: true,
          options: this.monthList(),
        }, */
          {
            // 项目名称
            prop: 'projectCode',
            label: this.$t('costConfirmationList.column.projectName'),
            type: 'dict',
            required: true,
            dictType: 'produce_product_proname',
          },
          {
            // 成本确认账期
            prop: 'periodName',
            label: this.$t('costConfirmationList.column.periodName'),
            type: 'searchTable',
            searchType: 'pdPeriod',
            required: true,
            isMultiple: true,
            extraData: {
              projectCode: this.baseData.projectCode,
              periodStatus: 'opened',
            },
            currentValue: this.baseData.periodName,
          },
        ];
      },
      transOptions() {
        return [
          {
            // 运输仓储费合同日期
            type: 'date',
            label: this.$t('costConfirmationList.column.transAndStoreContractDate'),
            prop: 'contractDate',
          },
          {
            // 运输仓储费-不含税结算金额（元）
            type: 'amountNumber',
            label: this.$t('costConfirmationList.column.settlementAmountWithoutTax'),
            prop: 'settlementAmountWithoutTax',
            precision: this.$globalVar.pPoint,
            max: 999999999.999999,
            min: 0,
          },
          {
            // 运输仓储费-含税结算金额（元）
            type: 'amountNumber',
            label: this.$t('costConfirmationList.column.settlementAmountWithTax'),
            prop: 'settlementAmountWithTax',
            precision: this.$globalVar.pPoint,
            max: 999999999.999999,
            min: 0,
          },
          {
            // 运输仓储费-税率
            type: 'sixNumber',
            label: this.$t('costConfirmationList.search.taxRate'),
            prop: 'taxRate',
            precision: this.$globalVar.aPoint,
            max: 100,
            min: 0,
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            type: 'seq',
            width: 80,
            title: this.$t('costConfirmationList.column.sortNo'),
          },
          /* {
          field: "goodsType",
          title: this.$t("costConfirmationList.column.goodsType"),
          footerAlign:"center",
          width: 140,
          editRender: { name: "ElSelect", props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.goodsTypeName}</span>];
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder={this.$t(
                    "collarDetailsList.column.selectPlaceholder"
                  )}
                  type="productType"
                  value={row["goodsType"]}
                  onChange={(val, label) =>
                    this.handleChangeInput(val, label, row, "goodsType")
                  }
                ></dict-select>,
              ];
            },
          },
        }, */
          //原料编码
          {
            field: 'productCode',
            title: this.$t('costConfirmationList.column.productCode'),
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.productCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="produceProduct"
                    isMultiple={true}
                    currentValue={row['productCode']}
                    checkRowKeys={[row['productCode']]}
                    onInput={(val) => this.chooseTable(val, row)}
                    extraData={{
                      productStatus: '001',
                      productClass: '0',
                    }}
                  ></search-table>,
                ];
              },
            },
          },
          //原料名称
          {
            field: 'productName',
            title: this.$t('costConfirmationList.column.productName'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //规格型号
          {
            field: 'productSpec',
            title: this.$t('costConfirmationList.column.productSpec'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //主料/辅料
          {
            field: 'goodsType',
            title: this.$t('costConfirmationList.column.productType'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },
          //原料大类
          {
            field: 'productCategory',
            title: this.$t('costConfirmationList.column.productCategory'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true, disabled: true } },
          },

          /* {
          field: "productCode",
          title: this.$t("costConfirmationList.search.productCode"),
          editRender: { name: "ElInput", props: { clearable: true } },
          width: 140,
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>{ row.productName}</span>
              ]
            },
            edit: ({ row }) => {
              return [
                <search-table
                  searchType="produceProduct"
                  isMultiple={true}
                  currentValue={row['productName']}
                  checkRowKeys={[row['productCode']]}
                  onInput={val => this.chooseTable(val, row)}
                ></search-table>
              ]
            }
          }
        }, */
          {
            field: 'partnerName',
            title: this.$t('costConfirmationList.column.partnerCode'),
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            /* slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [<span>{row.partnerName}</span>];
            },
            edit: ({ row }) => {
              return [
                <ajax-select
                  placeholder={this.$t(
                    "collarDetailsList.column.selectPlaceholder"
                  )}
                  value={row.partnerCode}
                  apiUrl={DataBaseAPI.PARTNER_LIST_API}
                  // partnerType: "HZHB03",
                  apiData={{ requestStatus: "ZT03" }}
                  filterable={true}
                  valueType="object"
                  valueKey="partnerCode"
                  labelKey="partnerZhName"
                  method="post"
                  onChange={(val) =>
                    this.handleChangeInput(val, val, row, "partnerCode")
                  }
                ></ajax-select>,
              ];
            },
          }, */
          },
          {
            field: 'contractDate',
            title: this.$t('costConfirmationList.column.contractDate'),
            editRender: {
              name: 'ElDatePicker',
              props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
            },
            width: 180,
          },
          {
            field: 'settlementCount',
            title: this.$t('costConfirmationList.column.settlementCountUnit'),
            maxlength: '20',
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.settlementCount}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['settlementCount']}
                    precision={this.$globalVar.qPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementCount')}
                  ></input-number>,
                ];
              },
            },
          },
          {
            field: 'settlementPriceWithoutTax',
            title: this.$t('costConfirmationList.column.settlementPriceWithoutTaxUnit'),
            maxlength: '20',
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.settlementPriceWithoutTax)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementPriceWithoutTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) =>
                      this.handleChangeNumber(val, row, 'settlementPriceWithoutTax')
                    }
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'settlementAmountWithoutTax',
            title: this.$t('costConfirmationList.column.settlementAmountWithoutTaxUnit'),
            maxlength: '20',
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                /* row["settlementAmountWithoutTax"] = this.$cal.accMul(row["settlementCount"],row["settlementPriceWithoutTax"])+""; */
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.settlementAmountWithoutTax)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementAmountWithoutTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) =>
                      this.handleChangeNumber(val, row, 'settlementAmountWithoutTax')
                    }
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'settlementPriceWithTax',
            title: this.$t('costConfirmationList.column.settlementPriceWithTaxUnit'),
            maxlength: '20',
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.settlementPriceWithTax)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementPriceWithTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementPriceWithTax')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'settlementAmountWithTax',
            title: this.$t('costConfirmationList.column.settlementAmountWithTaxUnit'),
            maxlength: '20',
            width: 140,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.settlementAmountWithTax)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['settlementAmountWithTax']}
                    precision={this.$globalVar.pPoint}
                    max={99999999999.999999}
                    onInput={(val) => this.handleChangeNumber(val, row, 'settlementAmountWithTax')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'taxRate',
            title: this.$t('costConfirmationList.column.taxRate'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            width: 140,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.taxRate != '' ? row.taxRate + '%' : '13%'}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row['taxRate'] != null ? row['taxRate'] + '%' : '13%'}
                    max={100}
                    onInput={(val) => this.handleChangeNumber(val, row, 'taxRate')}
                  ></input-number>,
                ];
              },
            },
          },
        ];
      },
      rules() {
        return {
          /* goodsType: [
          {
            required: true,
            message: this.$t(
              "costConfirmationList.placeholder.goodsType"
            ),
          },
        ], */
          productName: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.productName'),
            },
          ],
          productCode: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.productCode'),
            },
          ],
          settlementCount: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.settlementCount'),
            },
          ],
          settlementPriceWithoutTax: [
            {
              required: true,
              message: this.$t('costConfirmationList.placeholder.settlementPriceWithoutTax'),
            },
          ],
          taxRate: [
            {
              required: true,
            },
          ],
        };
      },
    },
    data() {
      return {
        activeNames: ['1', '2', '3'], //默认展开所有面板
        tableData: [],
        yearList: [], //年度
        monthList() {
          //月份
          var mon = [];
          for (let i = 1; i < 13; i++) {
            mon.push({
              label: i + this.$t('costConfirmationList.column.month'),
              value: i,
            });
          }
          return mon;
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        baseData: {
          businessCompanyCode: null, // 公司
          businessCompanyName: null, // 公司名称
          businessDepartmentCode: null, // 部门
          businessDepartmentName: null, // 部门名称
          createPersonName: null, // 创建人
          createDate: dateFormat(new Date()), // 创建日期
          settlementCount: null, // 结算数量
          settlementAmountWithoutTax: null, // 不含税结算金额
          settlementAmountWithTax: null, // 含税结算金额
          confirmNo: null, //成本确认单号
          //confirmYear: null, // 成本确认年度
          //confirmMonth: null, // 成本确认月份
          projectCode: null, //项目名称编码
          projectName: null, //项目名称
          periodCode: null, //成本确认账期编码
          periodName: null, //成本确认账期
        },
        baseTransData: {
          productName: '运输仓储费', //运输仓储费名称
          settlementAmountWithoutTax: null, // 不含税结算金额
          settlementAmountWithTax: null, // 含税结算金额
          taxRate: '6',
          contractDate: null, // 运输仓储费合同日期
        },

        addRowObj: {
          productConfirmName: null,
          confimProductNameSpec: null,
        },
      };
    },
    mounted() {
      this.getYearList();
      this.getComany();
      if (this.$route.name.indexOf('Add') != -1) {
        // ['companyCode', 'companyName', 'departmentCode', 'departmentName'].map(item => {
        //   this.baseData[item] = this.userInfo[item];
        // });
        this.baseData.createPersonName = this.userInfo.userName;
      } else {
        this.getData();
      }
    },
    methods: {
      //获取值
      chooseTable(val, row) {
        row.productName = val[0].productName;
        row.productCode = val[0].productCode;
        row.productSpec = val[0].productSpec;
        row.goodsType = this.$baseRequest.getDictValueByType('productType', val[0].productType);
        row.productCategory = this.$baseRequest.getDictValueByType(
          'produce_product_category',
          val[0].productCategory
        );
      },
      // 表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'businessCompanyCode') {
          this.changeCompany(value.businessCompanyCode);
        }
        if (prop == 'projectCode') {
          this.baseData.periodCode = this.baseData.periodName = null;
          this.baseData.projectCode = value.projectCode;
          this.baseData.projectName = this.$baseRequest.getDictValueByType(
            'produce_product_proname',
            value.projectCode
          );
        }
        if (prop == 'periodName') {
          let res = value.periodName;
          if (res && res.length > 0) {
            this.baseData.periodCode = res[0].periodCode;
            this.baseData.periodName = res[0].periodName;
          } else {
            this.baseData.periodCode = this.baseData.periodName = null;
          }
        }
      },
      // 运输仓储费表单变化
      handleChangeBaseTransData(value, prop) {
        if (prop == 'settlementAmountWithoutTax' || prop == 'taxRate') {
          this.baseTransData.settlementAmountWithTax = this.$cal.calCommon(
            this.baseTransData.settlementAmountWithoutTax,
            this.$cal.calCommon(1, this.baseTransData.taxRate / 100, '+'),
            '*',
            'price'
          );
        }
        this.updateData();
      },
      // 返回表单数据
      exportBaseData() {
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      // 返回运输仓储费表单数据
      exportBaseTransData() {
        let sign = false;
        this.$refs.baseTransData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseTransData : false;
      },
      // 返回表格数据
      exportTableData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate().then(() => {
            resolve(tableData);
          });
        });
      },
      //获取搜索框当前公司
      getComany() {
        this.companyList = JSON.parse(this.userInfo.companyList);
        this.companyList.forEach((item) => {
          item.value = item.personCompanyCode;
          item.label = item.personCompanyName;
        });
        this.baseData.businessCompanyCode = this.companyList[0].value;
        this.baseData.businessCompanyName = this.companyList[0].label;
        this.changeCompany(this.baseData.businessCompanyCode);
      },
      // 获取公司部门
      async changeCompany(val) {
        this.baseData.businessDepartmentCode = null;
        let personDepartmentInfo = [];
        if (val) {
          const params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
          };
          this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
            if (res.data.code === 0) {
              personDepartmentInfo = res.data.data.personDepartmentInfo.map((item) => {
                return {
                  value: item.personDepartmentCode,
                  label: item.personDepartmentName,
                };
              });
              this.departmentList = personDepartmentInfo;
              this.baseData.businessDepartmentCode = this.departmentList[0].value;
              this.baseData.businessDepartmentName = this.departmentList[0].label;
            }
          });
        } else {
          this.departmentList = [];
        }
      },

      async handleSave(btnType) {
        let baseData = this.exportBaseData();
        let baseTransData = this.exportBaseTransData();
        console.log(baseData, btnType);
        let details = await this.exportTableData();
        //this.storageAndTran.contractDate = baseData.contractDate;
        //details.push(this.storageAndTran);

        if (baseData && baseTransData && details) {
          baseData = this.$baseRequest.assignObj(baseData);
          details.push(baseTransData);
          let params = {
            ...baseData,
            details,
          };
          this.loading.startLoading();
          let res = await this.$axios.post(API.ADD_PD_COST_CONFIRM, params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.saveSussess'),
                type: 'success',
              });
              this.$baseRequest.linkBackRouteUrl(
                '/production/costConfirmationAdd',
                'costConfirmationAdd',
                '',
                '/production/costConfirmationList',
                'costConfirmationList',
                ''
              );
            } else {
              this.$message({
                showClose: true,
                message: this.$t('alert.error'),
                type: 'error',
              });
            }
          }
        }
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.table.validate().then(() => {
          let record = {
            taxRate: '13',
          };
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      handleChangeInput(val, label, row, type) {
        if (type == 'goodsType') {
          row[type] = val;
          row.goodsTypeName = label;
          row.productCode = '';
          row.productName = '';
          row.goodsType = null;
          setTimeout(() => {
            row.goodsType = val;
          }, 10);
        }
        if (type == 'productCode') {
          row[type] = val.value;
          row.productName = val.label;
        }
        if (type == 'partnerCode') {
          row[type] = val.partnerCode;
          row.partnerName = val.partnerZhName;
        }
      },
      handleChangeNumber(val, row, type) {
        row[type] = val;
        if (type == 'settlementCount' || type == 'settlementPriceWithoutTax' || type == 'taxRate') {
          row.settlementAmountWithoutTax = this.$cal.calCommon(
            row.settlementCount,
            row.settlementPriceWithoutTax,
            '*',
            'price'
          );
          row.settlementPriceWithTax = this.$cal.calCommon(
            row.settlementPriceWithoutTax,
            this.$cal.calCommon(1, row.taxRate / 100, '+'),
            '*',
            'price'
          );
          row.settlementAmountWithTax = this.$cal.calCommon(
            row.settlementCount,
            row.settlementPriceWithTax,
            '*',
            'price'
          );
          // 实时更新数据
          this.updateData();
        }
        /* if(type=="settlementAmountWithoutTax"||type=="settlementAmountWithTax"){
          row[type] = val;
        } */
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      // 删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancelled'),
            });
          });
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear() - 5;
        for (let i = 0; i < 10; i++) {
          year = year + 1;
          let object = { value: `${year}` + '', label: year + '' };
          this.yearList.push(object);
        }
      },
      footerMethod({ columns, data }) {
        return [
          //运输仓储费
          /*  columns.map((column, columnIndex) => {

          if (["productCode"].includes(column.property)) {
            return this.$t("costConfirmationList.column.tranAndStoreCost");
          }
          if (["taxRate"].includes(column.property)) {
            return "6%";
          }
          if (["settlementAmountWithoutTax"].includes(column.property)) {
            return this.storageAndTran.settlementAmountWithoutTax=data.map(i=>i['settlementAmountWithoutTax']).reduce(( acc, cur ) => {
                const num =this.$cal.accAdd(acc, cur)
                return num;
                }, 0)
          }
          if (["settlementAmountWithTax"].includes(column.property)) {
            return this.storageAndTran.settlementAmountWithTax=this.$cal.accMul(data.map(i=>i['settlementAmountWithoutTax']).reduce(( acc, cur ) => {
                const num =this.$cal.accAdd(acc, cur)
                return num;
                }, 0),1.06)
          }
          return null;
        }), */
          //小计
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('costConfirmationList.column.subTotal');
            }
            if (columnIndex === 1) {
              return this.$t('costConfirmationList.column.count');
            }
            if (['settlementCount'].includes(column.property)) {
              return (this.baseData.settlementCount = data
                .map((i) => i['settlementCount'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0));
            }
            if (['settlementAmountWithoutTax'].includes(column.property)) {
              return (this.baseData.settlementAmountWithoutTax = data
                .map((i) => i['settlementAmountWithoutTax'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return this.$cal.calCommon(
                    num,
                    this.baseTransData.settlementAmountWithoutTax,
                    '+'
                  );
                }, 0));
            }
            if (['settlementAmountWithTax'].includes(column.property)) {
              return (this.baseData.settlementAmountWithTax = data
                .map((i) => i['settlementAmountWithTax'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return this.$cal.calCommon(num, this.baseTransData.settlementAmountWithTax, '+');
                }, 0));
            }
            return null;
          }),
        ];
      },
      footerColspanMethod({ columnIndex }) {
        if (columnIndex === 2) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        } else if (columnIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      },
      // 详情
      getData() {},
    },
  };
</script>
